import { render, staticRenderFns } from "./IntervalReport.vue?vue&type=template&id=72a5cba6&"
import script from "./IntervalReport.vue?vue&type=script&lang=js&"
export * from "./IntervalReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports